import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TimeService } from 'src/app/time.service';

@Component({
  selector: 'app-view-vehicle',
  templateUrl: './view-vehicle.component.html',
  styleUrls: ['./view-vehicle.component.scss']
})
export class ViewVehicleComponent implements OnInit {

  vehicleData :any = {};
  constructor(private dialog: MatDialogRef<ViewVehicleComponent>,
    @Inject(MAT_DIALOG_DATA) private parentData: any,private timeService: TimeService) { }

  ngOnInit() {
    this.vehicleData.vehicle_number = this.parentData.vehicleNumber || 'N/A';
    this.vehicleData.truck_type = this.parentData.vehicle.name || 'N/A';
    this.vehicleData.chassis_number = this.parentData.registration.chassis_number || 'N/A';
    this.vehicleData.engine_number =  this.parentData.registration.engine_number || 'N/A';
    this.vehicleData.registration_year = this.parentData.registration.year || 'N/A';
    this.vehicleData.mileage =  this.parentData.tank.mileage || '';
    this.vehicleData.mileage_unit = this.parentData.tank.mileage_unit || '' ;
    this.vehicleData.registration_id =  this.parentData.tank.registration_id || '';
    this.vehicleData.driver_name = this.parentData.attached.length ? this.parentData.attached[0].name : '';
    this.vehicleData.mobile_number = this.parentData.attached.length ? this.parentData.attached[0].mobile : '';
    this.vehicleData.gps_provider = this.parentData.gps ? this.parentData.gps.provider.toUpperCase()  : '';
    this.vehicleData.transporter = this.parentData.transporter || undefined;
  }

  closeDialog(){
    this.dialog.close();
  }

}
